// ====================== EBOARD ======================

// export const ProjectConstants = {
//     title: 'Sibasi EBoard',
//     websiteLink: 'https://sibasi.com/',
//     prefix: 'Sibasi',
//     useAlternateLogoOnAuth: true,
//     favicon: 'Sibasi_EBM-Suites_Emblem-favicon.png',
//     primaryColor: 'RGB(0, 112, 192)',
//     secondaryColor: 'RGB(0, 0, 0)',

//     //TODO:/************************** COMMENT AFTER DEMO **************************/

//     // emblemLogoLight: 'pacis emblem.png',
//     // emblemLogoDark: 'pacis emblem.png',
//     // nameLogoLight: 'pacis main.png',
//     // nameLogoDark: 'pacis main.png',
//     // lightLogo: 'pacis main.png',
//     // darkLogo: 'pacis main.png',
//     // whiteLogo: 'pacis main.png',
//     // alternateLogo: 'pacis main.png',
//     // authLightLogo: 'logo_full.png',
//     // authDarkLogo: 'logo_full.png',

//     //TODO:/************************** UNCOMMENT AFTER DEMO **************************/
//     emblemLogoLight: 'logo-current-emblem-only.svg',
//     emblemLogoDark: 'logo-current-emblem-only.svg',
//     nameLogoLight: 'logo_name.png',
//     nameLogoDark: 'logo_name.png',
//     lightLogo: 'logo_full.png',
//     darkLogo: 'logo_full.png',
//     whiteLogo: 'logo-white.svg',
//     alternateLogo: 'Sibasi_Logo_White_Text_No_bg.png',
//     organizationRedirectURL: '/organization/pending-invites',
//     privacyPolicyURL: 'https://sibasi.com/privacy-policy',
// };

// ====================== MONIVAL ======================

// export const ProjectConstants = {
//     title: 'Monitoring and Evaluation System',
//     websiteLink: 'https://monival.com/',
//     prefix: 'Monival',
//     nameLogo: 'Monival_Logo.png',
//     lightLogo: 'Monival_Logo.png',
//     darkLogo: 'Monival_Logo_White_Bg.png',
//     emblemLogoLight: 'Monival_Emblem.png',
//     emblemLogoDark: 'Monival_Emblem.png',
//     nameLogoLight: 'Monival_Logo.png',
//     nameLogoWhite: 'Monival_Logo_White.png',
//     emblemLogo: 'Monival_Emblem.png',
//     fullLogo: 'Monival_Logo.png',
//     alternateLogo: 'Monival_Logo_White_Bg.png',
//     logov2: 'White_Monival_Logo_No_CatchPhrase',
//     useAlternateLogoOnAuth: true,
//     favicon: 'Monival_Emblem.png',
//     primaryColor: 'rgb(41,94,13)',
//     secondaryColor: 'RGB(0, 0, 0)',
//     organizationRedirectURL: '/organization/pending-invites',
//     privacyPolicyURL: 'https://sibasi.com/privacy-policy',
// };

// ====================== EBMSUITE ======================

export const ProjectConstants = {
  title: 'Efficient Business Management Suite',
  websiteLink: 'https://ebmsuite.com',
  webAppLink: 'https://app.ebmsuite.com',
  appUrl: 'https://app.ebmsuite.com/#/',
  prefix: 'EBM Suite',
  nameLogo: 'logo-current-name-only.svg',
  lightLogo: 'logo-current.svg',
  darkLogo: 'logo-current.svg',
  emblemLogoLight: 'logo-current-emblem-only.svg',
  emblemLogoDark: 'logo-current-emblem-only.svg',
  emblemLogoStarter: 'logo-current-starter.svg',
  emblemLogoPremium: 'logo-current-premium.svg',
  nameLogoLight: 'logo-current-name-only.svg',
  nameLogoWhite: 'Sibasi_Logo_White_Text_No_bg.png',
  emblemLogo: 'logo-current-emblem-only.svg',
  fullLogo: 'logo-current.svg',
  whiteLogo: 'logo-white.svg',
  alternateLogo: 'Sibasi_Logo_White_Text_No_bg.png',
  logov2: 'Sibasi_Logo_White_Text_No_bg.png',
  useAlternateLogoOnAuth: true,
  favicon: 'Sibasi_EBM-Suite_Emblem-favicon.png',
  primaryColor: 'RGB(0, 112, 192)',
  secondaryColor: 'RGB(0, 0, 0)',
  organizationRedirectURL: '/organization/select',
  privacyPolicyURL: 'https://ebmsuite.com/terms',
  termsAndConditionURL: 'https://ebmsuite.com/terms'
};
